/*global define*/

/*

Usage:

<div id="uniqueTabContainerName">
  <ul class="nav--tabs">
   <li><a href="#uniqueTabName1" class="active">First Tab Name</li>
   <li><a href="#uniqueTabName2">Second Tab Name</li>
  </ul>
  <div id="uniqueTabName1">Content</div>
  <div id="uniqueTabName2">
    More content
  </div>
</div>

<script>
  var tabsContainer = $('#uniqueTabContainerName');
  var tabs = new Tabs(tabsContainer);
</script>

*/

/**
 * @constructor
 */
function Tabs(container) {
	this._container = container;
	this._tabs = this._loadElements();
	this.length = this._tabs.length;

	// Hide all tabs and reset classes on all of them.
	for(var i = 0; i < this._tabs.length; i++) {
		var tab = this._tabs[i];
		tab.anchor.removeClass('active');
		tab.container.removeClass('active');
		tab.container.hide();
	}
	var self = this;

	// Listen to click on tab headers.
	this._container.on('click', '.nav--tabs a', function (e) {
		e.preventDefault();
		for(var i = 0; i < self._tabs.length; i++) {
			if (self._tabs[i].anchor[0] === this) {
				return self.switchTab(i);
			}
		}
	});

	if (this.length > 0) {
		this.switchTab(0);
	}
	// Fire `tabscreate` event
	this._container.trigger('tabscreate');
}

/**
 * This function loads the tab elements and stores them in an array
 * return: Tab array
 */
Tabs.prototype._loadElements = function () {
	var $headers = this._container.children('ul');
	var tabs = [];

	this._container.addClass('tabs');
	$headers.addClass('nav--tabs');

	var self = this;
	$('li', $headers).each(function () {
		var $tab = $(this);
		var $anchor = $tab.find('a');
		var selector = $anchor.attr('href');
		var $container = self._container.find(selector);

		var tab = {
			active: false,
			tab: $tab,
			selector: selector,
			container: $container,
			anchor: $anchor
		};
		tabs.push(tab);
	});
	return tabs;
};

Tabs.prototype.count = function () {
	return this._tabs.length;
};

Tabs.prototype.getTab = function (index) {
	return this._tabs[index];
};

Tabs.prototype.getTagIndexBySelector = function (selector) {
	// Loop all tabs and return the tab that has the given selector.
	for (var i = 0; i < this._tabs.length; i++) {
		if (this._tabs[i].selector === selector) {
			return i;
		}
	}
	return -1;
};

Tabs.prototype.getCurrentTab = function () {
	var index = this.getCurrentTabIndex();
	return index >= 0 ? this._tabs[index] : null;
};

Tabs.prototype.getCurrentTabIndex = function () {
	// Loop all tabs and return the tab that is active.
	for (var i = 0; i < this._tabs.length; i++) {
		if (this._tabs[i].active) {
			return i;
		}
	}
	return -1;
};

Tabs.prototype.switchTab = function (index) {
	var currentTab = this.getCurrentTab();
	if (currentTab) {
		// close the current tab first
		currentTab.anchor.removeClass('active');
		currentTab.container.removeClass('active');
		currentTab.active = false;
		currentTab.container.slideUp(200);

	}

	// open new tab.
	var tab = this.getTab(index);
	tab.anchor.addClass('active');
	tab.container.addClass('active');
	tab.container.slideDown(200);
	tab.active = true;

	// Fire tabchange event with new and old tab.
	this._container.trigger('tabchange', {
		oldTab: currentTab,
		newTab: tab
	});
};


if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
	// AMD. Register as an anonymous module.
	define('tabs',['jquery'], function() {
		'use strict';
		return Tabs;
	});

} else {
	window.Tabs = Tabs;
};
